import { Typography } from 'antd'
import { AffectedValueProps } from './types'

const AffectedValue: React.FC<AffectedValueProps> = ({ label, value }) =>
  value ? (
    <Typography.Paragraph>
      {label}:{' '}
      <Typography.Text delete type="danger">
        {value}
      </Typography.Text>
    </Typography.Paragraph>
  ) : null

export default AffectedValue
